import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "inline-grid grid-flow-row gap-1 items-center" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, _toDisplayString(_ctx.address.street) + " " + _toDisplayString(_ctx.address.streetNumber), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.address.postalCode) + " " + _toDisplayString(_ctx.address.city), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.address.country), 1)
    ]));
}
